import { useState, useEffect, RefObject } from "react";

export default function useKeyEvent(ref: RefObject<HTMLUListElement>) {
	let target: HTMLElement | null = null;
	const [index, setIndex] = useState<number>(0);

	useEffect(() => {
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleClickOutside = (e: MouseEvent) => {
		if (!ref || !ref.current) return;
		const menuElm = ref.current.parentElement as HTMLElement;
		if (!menuElm.contains(e.target as Element)) {
			// outside click 인지 판단 및 초기화
			init();
		}
	};

	const init = () => {
		setIndex(0);
		target = null;
	};

	const handleKeyDown = (e: React.KeyboardEvent<HTMLUListElement>) => {
		if (!ref) return;
		switch (e.code) {
			case "ArrowDown":
				upCount();
				break;
			case "ArrowUp":
				downCount();
				break;
			default:
				break;
		}

		focusTarget();
	};

	const handleFocus = (e: React.FocusEvent<HTMLUListElement>) => {
		if (!ref) return;
		e.target.dataset["focus"] = "true";
	};
	const handleBlur = (e: React.FocusEvent<HTMLUListElement>) => {
		if (!ref) return;
		e.target.dataset["focus"] = "false";
	};

	const upCount = () => {
		const maxLength = getMaxLength();
		if (index >= maxLength) {
			setTarget(index);
		} else {
			setTarget(index + 1);
		}
	};

	const downCount = () => {
		if (index <= 0) {
			setTarget(index);
		} else {
			setTarget(index - 1);
		}
	};

	const setTarget = (index: number) => {
		setIndex(index);
		setFocusTarget(index);
	};

	const setFocusTarget = (index: number) => {
		if (!ref.current) return null;
		target = ref.current.children[index].querySelector(`[data-focus]`) as HTMLElement;
	};

	const focusTarget = () => {
		if (!target) return;
		target.focus();
	};

	const getMaxLength = () => (ref.current ? ref.current.children.length - 1 : 0);

	return {
		handleKeyDown,
		handleFocus,
		handleBlur
	};
}
